import React, { useState } from "react";
import { Show, SimpleShowLayout, useTranslate } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import DualListBox from "react-dual-listbox";
import { apiHost, headers } from "../../../components/common";

const useStyles = makeStyles({
  DualListWrapper: {
    padding: "20px 0 0 0",
  },
  DualListBox: {
    height: "450px",
  },
});

const CustomNameTextField = ({ record, source }) => {
  const translate = useTranslate();
  return `${translate("ra.sources.role")}: ${record[source]}`;
};

const DualListInput = ({ record }) => {
  const classes = useStyles();
  const [selectedState, setSelectedState] = useState(record?.role_permissions);

  const changeHandler = (selected) => {
    setSelectedState(selected);
    const data = { roleId: record.id, permissions: selected };
    fetch(`${apiHost}/api/system/role/assign_permission`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: headers(),
    });
  };

  return (
    <div className={classes.DualListWrapper}>
      {record && record.permissions && (
        <DualListBox
          className={classes.DualListBox}
          canFilter
          options={record.permissions}
          selected={selectedState || record?.role_permissions}
          onChange={changeHandler}
        />
      )}
    </div>
  );
};

const SystemRoleAssignPermission = ({ onCancel, ...props }) => {
  return (
    <Show actions={false} {...props}>
      <SimpleShowLayout>
        <CustomNameTextField source="role_name" />
        <DualListInput />
      </SimpleShowLayout>
    </Show>
  );
};

export default SystemRoleAssignPermission;
